import React, { useEffect, useRef, useState } from 'react';
import { Container, makeStyles, Grid, Button, Typography, Table, TableCell, TableRow, TableBody, Fade, Stepper, Step, StepLabel, colors } from '@material-ui/core';
import Page from 'components/Page';

import { FormatNumber, Header } from 'components';
import { ModalGeneral } from 'components';
// import serviciosOrden from 'utils/serviciosOrden'

import { useForm } from 'react-hook-form';
import getErrorMessage from 'utils/getErrorMessage';
import FormularioIncidencia from './FormularioIncidencia';
import serviciosCatalogo from 'utils/serviciosCatalogo';
import serviciosSolicitudes from 'utils/serviciosSolicitudes';

const useStyles = makeStyles((theme) => ({
    step: {
        "&$completed": {
            color: "rgb(76,175,80)"
        },
        "&$active": {
            color: theme.palette.primary
        },
    },
    btnAceptar: {
        color: colors.green[500],
      },
    active: {}, //needed so that the &$active tag works
    completed: {},
    // disabled: {},
}));

const actualizarEquipo = ( personas, dataGeneral, condiciones) => {
    let arrPersonas = dataGeneral.map(persona => persona.idpersona);
    if (condiciones.cond1)
        personas = personas.filter(per =>arrPersonas.includes(per.idpersona));
    return personas;
}

const FechaP = ({setMensaje, datoS, setCargando, edicionEspecial, permisos, guardar, accion, tipo, servicios,  ...props }) => {

    //inicializa variables
    const classes = useStyles();
    const formref = useRef();

    const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: '' });
    const [ctl, setCtl] = useState({ proyectos: [], personas: datoS?.personas || [], tipoincidencias: [], responsables: [] });

    const { register:registerProp, unregister:unregisterProp, handleSubmit:handleSubmitProp, errors:errorsProp, watch:watchProp, setValue:setValueProp, getValues:getValuesProp, control:controlProp } = useForm();
    // const { register:registerReq, unregister:unregisterReq, handleSubmit:handleSubmitReq, errors:errorsReq, watch:watchReq, setValue:setValueReq, getValues:getValuesProp, control:controlProp } = useForm();
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fechaActual = year + '-' + month + '-' + day;


    const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: '' });


    const estructuraPropuesta = (dataForm) => {
        let ma = "Incidencia registrada ";
        let idmalcance = 0;

        if(datoS.idmalcance){
            ma += " para modificación de alcance #" + datoS.idmalcance + " - " + datoS.titulo + ". ";
            idmalcance =  datoS.idmalcance;
        }
        guardar(dataForm, datoS.idsolicitud, ma, idmalcance);
    }
    

    
    useEffect(() => {

                registerProp('titulo', {required:{ value: true, message: 'Campo requerido'} });
                registerProp('descripcion', {required:{ value: true, message: 'Campo requerido'} });
                registerProp('involucrados', {required:{ value: true, message: 'Campo requerido'} });

    }, []);
    
    

    return (
        <Container maxWidth={false}>
            
                <Container>
                    <form autocomplete="off" onSubmit={handleSubmitProp(estructuraPropuesta)}>

                                <FormularioIncidencia
                                register={registerProp}
                                datoS={datoS}
                                errors={getErrorMessage(errorsProp)}
                                watch={watchProp}
                                setValue={setValueProp}/>
                            
                            
                        <Grid item container justify="flex-end">
                            <Button variant="text" color="primary" /*onClick={()=>guardar(dataReq)}*/ type="submit" style={{color:colors.green[500]}}>GUARDAR</Button>
                        </Grid>
                    </form>
                </Container>

            
            <ModalGeneral
                open={mAdvertencia.open}
                titulo='Advertencia'
                width='sm'
                ContenidoMensaje={mAdvertencia.mensaje}
                acciones={<React.Fragment>
                    <Button className="btnError" color="secondary" onClick={cerrarAdvertencia}>CERRAR</Button>
                    {Boolean(mAdvertencia.aceptar) &&
                        <Button color="primary" style={{color:colors.green[500]}} onClick={mAdvertencia.aceptar}>ACEPTAR</Button>
                    }
                </React.Fragment>}
            />
        </Container>
    );
};

export default FechaP;